import { Link } from 'react-router-dom';
import collectionsData from '../data/collections.json';
import { Icon, Reveal } from '../components/Primitives';
import Seo from '../components/Seo';
import { CtaBand, PageHero } from '../components/Shared';

const { collections, products } = collectionsData;

const countFor = (slug) => products.filter((p) => p.in.includes(slug)).length;

export default function Collections() {
  return (
    <>
      <Seo
        title="Collections"
        description="Bridal Heritage, Kundan & Polki, necklaces, earrings, bangles and rings — the collections held at Nikhil Jewellers, C G Road, Ahmedabad."
      />

      <PageHero
        eyebrow="The Collections"
        title="Six ways into the same craft"
        lede="Two signature edits and four categories. Everything shown is representative of current stock — weights, purity and stone detail are confirmed in the showroom."
        trail={[{ label: 'Home', to: '/' }, { label: 'Collections' }]}
      />

      <section className="bg-cream-50 py-16 sm:py-24">
        <div className="shell">
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {collections.map((c, i) => (
              <Reveal key={c.slug} delay={(i % 3) * 100}>
                <Link
                  to={`/collections/${c.slug}`}
                  className="group flex h-full flex-col border border-royal-800/10 bg-cream-100
                    transition-all duration-500 ease-luxe hover:border-gold-500/40 hover:shadow-plate"
                >
                  <div className="relative overflow-hidden bg-royal-800">
                    <div className="aspect-[4/5] overflow-hidden">
                      <img
                        src={`/assets/lookbook/${c.hero}.webp`}
                        alt={`${c.name} — worn`}
                        loading={i < 3 ? 'eager' : 'lazy'}
                        decoding="async"
                        /* Cropped from the top so the face and the jewellery survive
                           the 4:5 crop of a portrait studio frame. */
                        className="h-full w-full object-cover object-[center_18%]
                          transition-transform duration-[1200ms] ease-luxe group-hover:scale-[1.05]"
                      />
                    </div>
                    <span
                      className="absolute right-4 top-4 border border-gold-400/40 bg-royal-950/45 px-3 py-1
                        text-[10.5px] uppercase tracking-wide2 text-gold-300"
                    >
                      {countFor(c.slug)} pieces
                    </span>
                  </div>

                  <div className="flex flex-1 flex-col p-7">
                    <p className="eyebrow">{c.eyebrow}</p>
                    <h2 className="mt-3 font-display text-2xl font-normal text-royal-900">
                      {c.name}
                    </h2>
                    <p className="mt-1.5 font-display text-lg font-light italic text-maroon-700/85">
                      {c.tagline}
                    </p>
                    <p className="mt-4 flex-1 text-[13.5px] leading-relaxed text-royal-700/70">
                      {c.description}
                    </p>
                    <span
                      className="mt-6 inline-flex items-center gap-2 text-[11px] uppercase
                        tracking-wide2 text-maroon-700"
                    >
                      View collection
                      <Icon.Arrow className="h-3.5 w-3.5 transition-transform duration-500 ease-luxe group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBand
        eyebrow="Not sure where to start?"
        title="Tell us the occasion"
        text="Send us the date and the outfit colour. We will put together two or three suites to look at before you come in."
      />
    </>
  );
}
